import { render, staticRenderFns } from "./book-form.vue?vue&type=template&id=2176ce48"
import script from "./book-form.vue?vue&type=script&lang=js"
export * from "./book-form.vue?vue&type=script&lang=js"
import style0 from "./book-form.vue?vue&type=style&index=0&id=2176ce48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports